<template>
    <div id="pad-wrapper" class="animation-duration">
        <div class="row head">
            <div class="col-md-9">
                <h4>Список поставщиков</h4>
            </div>
            <div class="col-md-3">
                <el-button class="pull-right" type="success" @click="$router.push({name:'AddProvider'})">Добавить поставщика</el-button>
            </div>
        </div>

        <div class="row">
            <el-table
                    :data="providers"
                    :default-sort = "{prop: 'id', order: 'ascending'}"
                    style="width: 100%">
                <el-table-column
                        prop="id"
                        label="ID"
                        sortable
                        width="100">
                </el-table-column>
                <el-table-column
                        prop="on"
                        label="Статус"
                        sortable
                        width="150">
                    <template slot-scope="scope">
                        <el-switch
                                v-model="scope.row.on"
                                active-color="#13ce66"
                                @change="changeProviderStatus(scope.$index, scope.row)"
                        >
                        </el-switch>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="title"
                        label="Наименование"
                >
                </el-table-column>
                <el-table-column
                        prop="title"
                        label="Ссылка на прием данных"
                        sortable>
                    <template slot-scope="scope">
                        <span v-if="scope.row.id != 2">https://pxl.knam.pro/code/addphone.php?id={id}&pid={{scope.row.id}}&phone={номер телефона}</span>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="id"
                        label="Управление"
                        width="150">
                    <template slot-scope="scope">
                        <el-button type="warning" plain icon="el-icon-edit" circle size="mini" @click="$router.push({path:'/providers/edit/'+scope.row.id})"></el-button>
                        <el-button type="danger" plain icon="el-icon-delete" circle size="mini" @click="providerDelete(scope.row)"></el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>

<script>
    import {mapGetters,mapActions} from 'vuex'

    export default {
        computed: {
            ...mapGetters('Providers', {
                providers: 'GET_PROVIDERS'
            }),
        },
        mounted() {
            this.loadProviders()
        },
        methods: {
            ...mapActions('Providers', {
                loadProviders: 'loadProviders',
                editProvider: 'editProvider',
                deleteProvider: 'deleteProvider'
            }),
            changeProviderStatus(a,b) {
                this.editProvider(b)
            },
            providerDelete(provider) {
                this.$confirm('Вы действительно желаете удалить поставщика '+provider.title+'?', 'Внимание', {
                    confirmButtonText: 'Удалить',
                    cancelButtonText: 'Отмена',
                    type: 'warning'
                }).then(() => {
                    this.deleteProvider(provider)
                        .then(response => {
                            this.$message({
                                type: 'success',
                                message: response.data
                            })
                            this.loadProviders()
                        })

                })
            }
        }
    }
</script>

<style scoped>

</style>